export default __webpack_public_path__ + "static/media/speedkino_policy.a6526af1.png";